import { createAsyncThunk } from "@reduxjs/toolkit";
import { api } from "@data-phone/react-resource-server-auth";
import qs from "qs";

export const fetchHhExchangeNumbersLookups = createAsyncThunk<
  any,
  string | string[],
  { rejectValue: string }
>(
  "hhaexchange/fetchLookup",
  async (number, { rejectWithValue }) => {
    try {
      const query = `?${qs.stringify({ numbers: Array.isArray(number) ? number : [number] })}`;
      const response = await api.get(
        `${process.env.REACT_APP_API_BASE_URL}/integrations/hhaexchange/lookup/${query}`
      );

      return response.data;
    } catch (error: any) {
      console.error("❌ HHAeXchange Lookup Failed:", error);
      return rejectWithValue(error?.message || "Lookup failed");
    }
  }
);
